module.exports = __webpack_public_path__ + "static/media/DSC01579 - Version 2.27b7b135.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/DSC01579 - Version 2.JPG
// module id = 513
// module chunks = 0